module.exports = __webpack_public_path__ + "static/media/workshop5.c198f96c.jpg";